// extracted by mini-css-extract-plugin
module.exports = {"TeamInfo":"TeamDashboardComponent_TeamInfo__2eH1a","ArchiveState":"TeamDashboardComponent_ArchiveState__2KUmd"};